/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import * as consts from '../../../../../const';

const OrganizationFilter = ({ appliedFilters, onOrganizationChange, filtersByOrganizations }) => {
  const [isOpen, setOpen] = useState(false);
  const selectorRef = useRef(null);

  const onDocumentClick = (event) => {
    const target = event.target;
    const { current } = selectorRef;
    current !== target && !current.contains(target) && setOpen(false);
  };
  useEffect(() => {
    document.addEventListener('click', onDocumentClick);

    return () => {
      document.removeEventListener('click', onDocumentClick);
    };
  }, []);

  const appliedSitesFilterLabel = () =>
    appliedFilters.length === 0 ? (
      <div>All Sites ({filtersByOrganizations.length - 1})</div>
    ) : appliedFilters.length === 1 ? (
      filtersByOrganizations.find((filter) => filter.value === appliedFilters[0]).label
    ) : (
      <div>Multiple sites ({appliedFilters.length})</div>
    );

  const appliedSitesFilterInput = () =>
    appliedFilters.length <= 1 ? <div className="checkbox single" /> : <div className="checkbox multiple" />;

  const onOptionSelect = (disabled, filter) => () => {
    if (disabled) return;

    setOpen(false);
    onOrganizationChange(filter);
  };

  return (
    <div className="site-filter">
      <div className="site-filter-header">{consts.FILTER_BY_SITE}</div>

      <div className="site-filter-dropdown" ref={selectorRef}>
        <div className="site-filter-dropdown-header">
          <div className="site-filter-applied-filters">
            <label>
              {appliedSitesFilterInput()}
              {appliedSitesFilterLabel()}
            </label>
          </div>
          <div className={`site-filter-dropdown-action ${isOpen ? ' open' : ''}`} onClick={() => setOpen(!isOpen)} />
        </div>

        {isOpen && (
          <div className="site-filter-dropdown-options">
            {filtersByOrganizations.map((filter) => {
              const checked =
                (appliedFilters.length === 0 && filter.value === '') || appliedFilters.includes(filter.value);
              const disabled = appliedFilters.length === 0 && filter.value === '';
              return (
                <label key={filter.value} onClick={onOptionSelect(disabled, filter)}>
                  <div className={`checkbox ${checked ? 'single' : 'empty'}`} />
                  {filter.label}
                </label>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

OrganizationFilter.propTypes = {
  appliedFilters: PropTypes.array,
  onOrganizationChange: PropTypes.func,
  filtersByOrganizations: PropTypes.array
};

export default OrganizationFilter;
